import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowRight, Info, Phone } from 'lucide-react';
import Icon from '../components/Icon';
import useReveal from '../hooks/useReveal';
import { pricing, site } from '../mock/mock';

export default function Pricing() {
  useReveal();
  return (
    <div className="pt-20">
      <section className="bg-cream pt-20 pb-16 text-center">
        <div className="max-w-2xl mx-auto px-5">
          <p className="eyebrow text-sage-500 mb-3">{pricing.eyebrow}</p>
          <h1 className="text-5xl md:text-6xl font-serif font-bold text-ink mb-4">{pricing.title}</h1>
          <p className="text-ink/60 text-lg">{pricing.subtitle}</p>
        </div>
      </section>

      <section className="py-24">
        <div className="max-w-[1100px] mx-auto px-5">
          <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-6">
            {pricing.items.map((p, i) => (
              <div
                key={p.animal}
                className="bg-white rounded-2xl p-8 text-center shadow-sm border border-cream-dark hover:shadow-xl hover:-translate-y-1 transition-all reveal"
                style={{ transitionDelay: `${i * 70}ms` }}
              >
                <div className="w-14 h-14 rounded-full bg-sage-50 flex items-center justify-center mx-auto mb-5">
                  <Icon name={p.icon} size={26} className="text-sage-600" />
                </div>
                <h3 className="font-serif text-lg text-ink mb-3 min-h-[3.5rem] flex items-center justify-center">{p.animal}</h3>
                <p className="text-4xl font-serif font-bold text-sage-600">{p.price}</p>
                <p className="text-ink/50 text-sm mt-1">{p.unit}</p>
              </div>
            ))}
          </div>

          <div className="mt-10 space-y-4 max-w-3xl mx-auto">
            <div className="flex items-start gap-4 bg-cream rounded-2xl p-6 reveal">
              <Icon name="HeartPulse" size={22} className="text-sage-500 shrink-0 mt-0.5" />
              <p className="text-ink/70 text-[0.95rem] leading-relaxed">{pricing.rehabNote}</p>
            </div>
            <div className="flex items-start gap-4 bg-cream rounded-2xl p-6 reveal">
              <Info size={22} className="text-sage-500 shrink-0 mt-0.5" />
              <p className="text-ink/70 text-[0.95rem] leading-relaxed">{pricing.travel}</p>
            </div>
          </div>

          <div className="mt-14 text-center reveal">
            <p className="text-ink/60 mb-6">Prices are per session and every plan is tailored to your animal. Get in touch to arrange your first appointment.</p>
            <div className="flex flex-col sm:flex-row gap-4 justify-center">
              <a href={site.phoneHref} className="inline-flex items-center justify-center gap-2 border-2 border-sage-500 text-sage-600 hover:bg-sage-500 hover:text-white font-semibold px-8 py-3.5 rounded-full transition-all">
                <Phone size={18} /> Call {site.phone}
              </a>
              <Link to="/contact" className="inline-flex items-center justify-center gap-2 bg-sage-500 hover:bg-sage-600 text-white font-semibold px-8 py-3.5 rounded-full transition-all hover:-translate-y-0.5 hover:shadow-lg">
                Book an appointment <ArrowRight size={18} />
              </Link>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}
